module.exports = __webpack_public_path__ + "static/media/facebook-1.8e01b77e.svg";